import { Component, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { StoragePathPipe } from '../../_pipe/storage-path.pipe';
import { UserService } from '../../_services/user.service';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { AngularFirestore } from 'angularfire2/firestore';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  notifications = [];
  subs = new Subscription();
  userId = localStorage.getItem('currentUserId');


  constructor(
    private afs: AngularFirestore, private cd: ChangeDetectorRef,
    private zone: NgZone, private router: Router, private userService: UserService) {

  }

  ngOnDestroy() {
    this.subs.unsubscribe();


  }

  ngOnInit() {
    this.afs.collection('users').doc(this.userId).collection('notifications').ref.where('isUnseen', '==', true).get().then((data) => {
      data.forEach(isSeen => {
        this.afs.collection('users').doc(this.userId).collection('notifications').doc(isSeen.id).update({ isUnseen: false })
      })
    })

    this.zone.run(() => {
      try {
        this.subs.add(this.afs.collection('users').doc(this.userId).collection('notifications').valueChanges().subscribe(notification => {
          if (notification) {
            this.notifications = notification;
            this.notifications = this.notifications.sort(function (a, b) {
              a = a.modifyDate;
              b = b.modifyDate;
              return a > b ? -1 : a < b ? 1 : 0;
            });


          }
        }));

      } catch (e) { }
    });

  }
  deleteAllNotif() {
    this.afs.collection('users').doc(this.userId).collection('notifications').ref.get().then((data => {
      data.forEach(notification => {
        this.afs.collection('users').doc(this.userId).collection('notifications').doc(notification.id).delete();
      })
    }))
    this.cd.markForCheck();

  }
  x(action) {

    this.afs.collection('users').doc(this.userId).collection('notifications').ref.where('modifyDate', '==', action).get().then((data => {
      this.afs.collection('users').doc(this.userId).collection('notifications').doc(data.docs[0].id).delete();

    }));
  }
  goTo(notification) {
    if (notification.action)
      this.zone.run(() => {
        this.router.navigate([notification.action]);
      });

  }
  getImageUrl(image) {
    let stPath = new StoragePathPipe();
    return stPath.transform(image);
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/notifications/notifications.component.ts